<template>
	<div>
		<aboutCenNav ref="aboutCenNav" :list="navList" @goScroll="goScroll" v-show="cenNavHidden"></aboutCenNav>
		<div class="aboutBoxOne" id='gywm' ref="gywm">
			<aboutCenGywm :gywm='gywm'></aboutCenGywm>
		</div>
		<aboutCenGywmTwo :gywm='gywmTwo'></aboutCenGywmTwo>
		<div class="aboutBoxTwo" id='fzls' ref="fzls">
			<indexTitle :title="$t('发展历史')" :more="false"></indexTitle>
			<aboutCenFzls :fzls='fzlsList'></aboutCenFzls>
		</div>
		<div id='qqbj' ref="qqbj"></div>
		<template v-if="headerShow">
			<div class="aboutBoxThree">
				<div>
					<indexTitle :title="$t('全球布局')" :more="false"></indexTitle>
					<aboutMap :qqbj='qqbjList'></aboutMap>
				</div>
			</div>
		</template>
		<template v-else>
			<indexTitle :title="$t('关于我们')" :more="false" ></indexTitle>
		</template>
		<aboutQqbj :qqbj='qqbjListTwo'></aboutQqbj>
	</div>
</template>

<script>
	import aboutCenNav from "./aboutCenNav"
	import indexTitle from "./indexTitle"
	import aboutCenGywm from "./aboutCenGywm"
	import aboutCenGywmTwo from "./aboutCenGywmTwo"
	import aboutCenFzls from "./aboutCenFzls"
	import aboutMap from "./aboutMap"
	import aboutQqbj from "./aboutQqbj"
	import {
		get_about
	} from "@/api/about.js"
	export default {
		components: {
			aboutCenNav,
			indexTitle,
			aboutCenGywm,
			aboutCenGywmTwo,
			aboutCenFzls,
			aboutMap,
			aboutQqbj
		},
		data() {
			return {
				navList: [{
						name: this.$t('发展历史'),
						value: 'gywm',
					},
					{
						name: this.$t('全球布局'),
						value: 'fzls',
					},
					{
						name: this.$t('消化科'),
						value: 'qqbj',
					},
				],
				navHidden: false,
				scrollTop: 0,
				scrollTopNav: 0,
				cenNavHidden: true,
				navTop: [],
				querValue: '',
				gywm: {
					// title: '澳华内镜是一家从事电子内镜设备研发、生产和销售的高新技术企业。',
					// cen: '通过围绕内镜诊疗领域进行的系统性产品布局，目前产品已包含4K超高清内镜系统、光学放大内镜、消化内镜、鼻咽喉镜及支气管镜等，可覆盖消化科、耳鼻喉科、呼吸科、急诊科、ICU等临床科室。在长期的技术创新之下，我们已突破了内镜光学成像、图像处理、镜体设计、电气控制等领域的多项关键技术，不断推进精准诊疗与前沿科研探索。',
					// list: [{
					// 		name: this.$t('呼吸科'),
					// 		img: require('@/assets/about/xhk.png')
					// 	},
					// 	{
					// 		name: this.$t('耳鼻喉科'),
					// 		img: require('@/assets/about/hxk.png')
					// 	},
					// 	{
					// 		name: this.$t('急诊科'),
					// 		img: require('@/assets/about/ebhk.png')
					// 	},
					// 	{
					// 		name: this.$t('组织架构'),
					// 		img: require('@/assets/about/jzk.png')
					// 	},
					// 	{
					// 		name: 'ICU',
					// 		img: require('@/assets/about/icu.png')
					// 	},
					// ],
				},
				gywmTwo: {
					// img: require('@/assets/about/gywmbj.png'),
					// list: [{
					// 		img: require('@/assets/about/Vision.png'),
					// 		name: '愿景',
					// 		cen: '成为国际领先的内镜整体解决方案提供商'
					// 	},
					// 	{
					// 		img: require('@/assets/about/Mission.png'),
					// 		name: '使命',
					// 		cen: '让内镜诊疗变得普及和便捷'
					// 	},
					// 	{
					// 		img: require('@/assets/about/Value.png'),
					// 		name: '价值观',
					// 		cen: '专注  创新  持续学习  用户满意  共赢'
					// 	},
					// ]
				},
				fzlsList: [

					// {
					// 	time: '2013',
					// 	img: require('@/assets/about/fzls.png'),
					// 	list: [{
					// 		name: '推出首款4K超高清内镜系统AQ-300可搭载首款光学放大内镜，倍率可至100倍'
					// 	}, ]
					// },
					// {
					// 	time: '2016',
					// 	img: require('@/assets/about/fzls.png'),
					// 	list: [{
					// 		name: '推出首款4K超高清内镜系统AQ-300可搭载首款光学放大内镜，倍率可至100倍'
					// 	}, ]
					// },
					// {
					// 	time: '2017',
					// 	img: require('@/assets/about/fzls.png'),
					// 	list: [{
					// 		name: '推出首款4K超高清内镜系统AQ-300可搭载首款光学放大内镜，倍率可至100倍'
					// 	}, ]
					// },
					// {
					// 	time: '2018',
					// 	img: require('@/assets/about/fzls.png'),
					// 	list: [{
					// 		name: '推出首款4K超高清内镜系统AQ-300可搭载首款光学放大内镜，倍率可至100倍'
					// 	}, ]
					// },
					// {
					// 	time: '2019',
					// 	img: require('@/assets/about/fzls.png'),
					// 	list: [{
					// 		name: '推出首款4K超高清内镜系统AQ-300可搭载首款光学放大内镜，倍率可至100倍'
					// 	}, ]
					// },
					// {
					// 	time: '2020',
					// 	img: require('@/assets/about/fzls.png'),
					// 	list: [{
					// 		name: '推出首款4K超高清内镜系统AQ-300可搭载首款光学放大内镜，倍率可至100倍'
					// 	}, ]
					// },
					// {
					// 	time: '2021',
					// 	img: require('@/assets/about/fzls.png'),
					// 	list: [{
					// 		name: '推出首款4K超高清内镜系统AQ-300可搭载首款光学放大内镜，倍率可至100倍'
					// 	}, ]
					// },
					// {
					// 	time: '2022',
					// 	img: require('@/assets/about/fzls.png'),
					// 	list: [{
					// 		name: '推出首款4K超高清内镜系统AQ-300可搭载首款光学放大内镜，倍率可至100倍'
					// 	}, ]
					// },
					// {
					// 	time: '2023',
					// 	img: require('@/assets/about/fzls.png'),
					// 	list: [{
					// 			name: '推出首款4K超高清内镜系统AQ-300可搭载首款光学放大内镜，倍率可至100倍'
					// 		},
					// 		{
					// 			name: '推出首款4K超高清内镜系统AQ-300可搭载首款光学放大内镜，倍率可至100倍'
					// 		},
					// 		{
					// 			name: '推出首款4K超高清内镜系统AQ-300可搭载首款光学放大内镜，倍率可至100倍'
					// 		},
					// 	]
					// },
				],
				qqbjList: [{
						name: '上海'
					},
					{
						name: '北京'
					},
					{
						name: '无锡'
					},
					{
						name: '杭州'
					},
					{
						name: '常州'
					},
					{
						name: '慕尼黑'
					},
				],
				qqbjListTwo: [{
						name: '上海',
						img: require('../../assets/about/sw.png'),
						list: [{
								name: '镜体和光学成像研发中心'
							},
							{
								name: '内镜生产总部'
							},
						]
					},
					{
						name: '北京',
						img: require('../../assets/about/sw.png'),
						list: [{
							name: '图像处理研发中心'
						}, ]
					},
					{
						name: '无锡',
						img: require('../../assets/about/sw.png'),
						list: [{
							name: '机电控制研发中心'
						}, ]
					},
					{
						name: '杭州',
						img: require('../../assets/about/sw.png'),
						list: [{
							name: '具备完整、成熟的生产流水线'
						}, ]
					},
					{
						name: '常州',
						img: require('../../assets/about/sw.png'),
						list: [{
							name: '高效制造基地，可快速响应市场和客户定制要求'
						}, ]
					},
					{
						name: '慕尼黑',
						img: require('../../assets/about/sw.png'),
						list: [{
							name: '国际内镜生产基地'
						}, ]
					},
				]
			}
		},
		watch: {
			scrollTop() {
				if (this.scrollTop < this.scrollTopNav) {
					this.cenNavHidden = true;
				}
				this.navList.map((v, a) => {
					if (this.scrollTop == 0) {
						this.$refs.aboutCenNav.current = 0;
						return;
					}
					if (a + 1 == this.navList.length) {
						if ((this.scrollTop + 70) > this.navTop[a]) {
							this.$refs.aboutCenNav.current = a;
						}
					} else {
						if ((this.scrollTop + 70) > this.navTop[a] && (this.scrollTop + 70) < this.navTop[a + 1]) {
							this.$refs.aboutCenNav.current = a;
						}
					}

					// if(!this.navHidden){
					// 	if (offsetTop > this.navTop[a]&&offsetTop< this.navTop[a+1]) {
					// 		this.$refs.aboutCenNav.current=a;
					// 	}
					// 	return;
					// }
					// if (offsetTop > this.scrollTop) {
					// 	this.$refs.aboutCenNav.current=a
					// }
				})
			},
			querValue() {
				let t = this;
				t.setTop();
			}
		},

		mounted() {
			let t = this;
			let offsetTop = this.$refs.aboutCenNav.$el.offsetTop;
			this.scrollTopNav = offsetTop;
			window.addEventListener('scroll', this.handleScroll);
			this.querValue = this.$route.query.value;
			this.$nextTick(function() {
				var element;
				if(this.nowVibe=='pc'){
					element= document.documentElement
				}else{
					element = document.documentElement.scrollTop ? document.documentElement : document.body;
				}
				t.scrollTop = element.scrollTop;
				// t.scrollTop = document.documentElement.scrollTop;
				// t.getTop();
			})
			console.log(this.querValue, "嗷嗷")
			this.getAboutInfo();

		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
		},
		methods: {
			setTop() {
				this.navList.map((v, a) => {
					if (this.querValue == v.value) {
						this.$refs.aboutCenNav.current = a;
						this.goScroll(this.querValue)
					}

				})
			},
			getTop() {
				let top = [];
				this.navList.map((v, a) => {
					if (v.value == 'qb') {
						top.push('')
					} else {
						try{
							console.log(this.$refs[v.value],this.$refs[v.value].offsetTop)
							top.push(this.$refs[v.value].offsetTop)
						}catch(e){
							//TODO handle the exception
						}
						// top.push(this.$refs[v.value].$el.offsetTop)
						console.log(top)
					}
				})
				this.$nextTick(function() {
					this.navTop = top;
				})
				console.log(this.navTop)
			},
			goScroll(e) {
				// let offsetTop = this.$refs[e].$el.offsetTop - 70;
				let offsetTop = document.getElementById(e).offsetTop - 56;
				this.$emit('goScroll', offsetTop)
				// let el=this.$refs[e].$el;
				// window.scrollTo({
				// 	top: this.offset(el) - 70,
				// 	behavior: "smooth"
				// });
			},
			handleScroll(e) {
				var element;
				if(this.nowVibe=='pc'){
					element= document.documentElement
				}else{
					element = document.documentElement.scrollTop ? document.documentElement : document.body;
				}
				// var element = document.documentElement.scrollTop ? document.documentElement : document.body;
				this.scrollTop = element.scrollTop;
			},
			getAboutInfo() {
				let t = this;
				let data = {}
				get_about(data).then(res => {
					console.log(res)
					this.gywm = res.data.info.about;
					this.gywmTwo = res.data.info.about
					this.fzlsList = res.data.info.history
					this.qqbjList = res.data.info.global_layout
					this.qqbjListTwo = res.data.info.global_layout.tableData
					this.$nextTick(function() {
						t.getTop();
					})
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.aboutBoxOne {
		width: 1200px;
		margin: 0px auto;
		padding-top: 150px;
	}

	.aboutBoxTwo {
		width: 1200px;
		margin: 0 auto;
		background-color: #fff;
		padding-top: 185px;
	}

	.aboutBoxThree {
		width: 100%;
		background-color: #ECECEC;

		>div {
			width: 1200px;
			margin: 0px auto;
			padding-top: 110px;
		}
	}

	@media screen and (max-width:1200px) {
		.aboutBoxOne {
			width: 100% !important;
			padding-top: 30px !important;
		}

		.aboutBoxTwo {
			width: 100% !important;
			padding-top: 30px !important;
		}

		.aboutBoxThree {
			>div {
				width: 100% !important;
				padding-top: 30px !important;
			}
		}
	}
</style>